// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yYjV","newExpiryDate":"styles_newExpiryDate__3_A2d","footer":"styles_footer__2vwA_"};